import "./OurExpertise.module.css";
import WebsiteHeader from "@/reusable_sections/Header";
import ServiceDetails from "./sections/ServiceDetails";
import TailoredDigitalSolutions from "./sections/TailoredDigitalSolutions";
import ReadyForImpact from "./sections/ReadyForImpact";
import Footer from "@/reusable_sections/Footer";
export default function OurExpertisePage() {
  return <div>
      <WebsiteHeader />
      <ServiceDetails />
      <TailoredDigitalSolutions />
      <ReadyForImpact />
      <Footer />
    </div>;
}